import { getStorage } from 'common-storage';

import { prop } from './prop';

export async function getCountryCode() {
  const storage = getStorage();

  const geoIp = await storage.getItem('geoip');
  if (geoIp && new Date().getTime() < JSON.parse(geoIp).expiry) {
    const geoIpData = JSON.parse(geoIp);
    if (geoIpData.country_code) {
      return Promise.resolve(geoIpData).then(prop('country_code'));
    }
  }

  return fetch('https://geoip.cactusglobal.io/json/', {
    method: 'GET',
  })
    .then((result) => result.json())
    .then((result) => {
      const expire = new Date();
      const time = Date.now() + 3600 * 1000 * 24;
      expire.setTime(time);
      result.expiry = expire.getTime();
      // For some ips country code is not coming, so setting default value as 'US'
      if (!result.country_code) {
        result.country_code = 'US';
      }
      storage.setItem('geoip', JSON.stringify(result));
      return result;
    })
    .then(prop('country_code'))
    .catch((error) => {
      console.error('Error fetching country code:', error);
      return 'US'; // Return default value 'US' in case of error
    });
}
